import React from "react";
import MonthSelector from "./MonthSelector";

function MonthScheduleTypeGrouping(props) {
  return (
    <div>
      <div className="flex justify-between items-center">
        <MonthSelector
          currentMonth={props.currentMonth}
          currentYear={props.currentYear}
          increment_month={props.increment_month}
          setCurrentMonth={props.setCurrentMonth}
          setCurrentYear={props.setCurrentYear}
        />
      </div>
    </div>
  );
}

export default MonthScheduleTypeGrouping;
